export default __webpack_public_path__ + "static/media/img_001.d9591573.png";